<template>
  <div class="root-container">
    <el-form ref="registerRef" label-width="150px" size="small">
      <el-row>
        <el-col :span="12">
          <el-form-item label="卡ID:">
            <el-input readonly="true" style="width: 270px" v-model="cardInfoID" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
          <el-form-item label="手机号:">
            <el-input readonly="true" style="width: 270px" v-model="cardInfo.userPhone" placeholder=""></el-input>
          </el-form-item>
        </el-col> -->
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="会员名字:">
            <el-input readonly="true" style="width: 270px" v-model="cardInfoName" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
          <el-form-item label="手机号:">
            <el-input readonly="true" style="width: 270px" v-model="cardInfo.userPhone" placeholder=""></el-input>
          </el-form-item>
        </el-col> -->
      </el-row>
      <!-- <el-row>
        <el-col :span="12">
          <el-form-item label="会员姓名:">
            <el-input readonly="true" style="width: 270px" v-model="cardInfo.childName" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="卡名称:">
            <el-input readonly="true" style="width: 270px" v-model="cardInfo.cardName" placeholder=""></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="金额:">
            <el-input readonly="true" style="width: 270px" v-model="cardInfo.totalPay" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="剩余正价课时:">
            <el-input readonly="true" style="width: 270px" v-model="cardInfo.remainingClassDes" placeholder=""></el-input>
          </el-form-item>
        </el-col>
      </el-row> -->
      <!-- <el-row>
        <el-col :span="12">
          <el-form-item label="正价课时:">
            <el-input readonly="true" style="width: 270px" v-model="cardInfo.totalLesssonCount" placeholder=""></el-input>
          </el-form-item>
        </el-col> -->
      <!-- <el-col :span="12">
          <el-form-item label="剩余赠送课时:">
            <el-input
              readonly="true"
              style="width: 270px"
              v-model="cardInfo.totalGiveCount"
              placeholder=""
            ></el-input>
          </el-form-item>
        </el-col> -->
      <!-- </el-row> -->
      <!-- <el-row>
        <el-col :span="12">
          <el-form-item label="赠送课时:">
            <el-input readonly="true" style="width: 270px" v-model="cardInfo.totalGiveCount" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="当前有效期:">
            <el-input readonly="true" style="width: 270px" v-model="cardInfo.cardEndTime" placeholder=""></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注:">
        <el-input v-model="cardInfo.remark" type="textarea" :autosize="{ minRows: 4 }" placeholder="请输入内容"
          style="width: 714px"></el-input>
      </el-form-item> -->

      <!-- <el-form-item label="卡类型:" >
            <el-input  readonly="true" style="width: 240px;"  v-model="cardInfo.cardName" placeholder=""></el-input>
          </el-form-item> -->
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleStopCard('registerRef')">保存</el-button>
    </span>
    <worker-word ref="workerWord" :key="refreshWord" :word-type="wordType" :t-data="tData" :show="showWordDlg"
      @onWorkerWord="handleWord"></worker-word>
  </div>
</template>

<script>
import {
  clientShunt
} from "@/api/userByCard";
import globaldata from "../../../utils/globaldata";
import WorkerWord from "@/components/WorkerWord/WorkerWord";
export default {
  props: {
    cardInfo: Object,
    selectList: Array
  },
  components: {
    WorkerWord,
  },
  data() {
    return {
      refreshWord: new Date().getTime(),
      tData: {
        adminWord: ''
      },
      wordType: 0,
      showWordDlg: false,
      cardInfoID: '',
      cardInfoName: '',
      list: []
    };
  },
  created() {
    this.initData();
    // userId: this.cardInfo.userId,
    console.log(this.selectList,'this.cardInfoID========')

    //     cardId: this.cardInfo.id,
    this.selectList.forEach(itm => {
      this.list.push(
        {
          userId:itm.userId,
          cardId:itm.id,
        }
      )

      this.cardInfoID = this.cardInfoID != '' ? this.cardInfoID + ',' + itm.id : itm.id
      this.cardInfoName = this.cardInfoName != '' ? this.cardInfoName + ',' + itm.childName : itm.childName
      
    });
  },
  methods: {
    handleWord(wordType, tData) {
      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        adminWord: tData.adminWord,
        list: this.list
      }
      clientShunt(param).then((res) => {
        if (res.code == 20000) {
          this.$emit("onBtnCreate");
        }
      })
    },
    initData() { },
    handleCancel() {
      this.$emit("onBtnCancel");
    },
    handleStopCard(registerRef) {
      this.$refs['workerWord'].showDlog = true

      // this.$refs[registerRef].validate((valid) => {
      //   if (valid) {
      //     //   let param = this.createParam;
      //     //   param.storeFrontId = globaldata.getAdminStore().storeFrontId;
      //     //   param.createAdminId = globaldata.getAdminStore().id;
      //     //   createUserChild(param).then((response) => {
      //     //     messageUtils.successMsg(this, "创建成功");
      //     //     this.$emit("onBtnCreate");
      //     //   });
      //   } else {
      //     return false;
      //   }
      // });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/user-by-lesson-card/components/shunt.vue